import React, { useCallback } from 'react';
import useDocumentTitle from '../shared/hooks/useDocumentTitle';
import { FaTiktok } from 'react-icons/fa';
import banner from '../assets/juega-con-forti/banner.webp';
import juego1Image from '../assets/juega-con-forti/juego-1.webp';
import juego2Image from '../assets/juega-con-forti/juego-2.webp';
import juego3Image from '../assets/juega-con-forti/juego-3.webp';
import juego4Image from '../assets/juega-con-forti/juego-4.webp';
import * as S from './JuegaConFortiPage.styles';

const GAMES = [
  {
    id: 1,
    image: juego1Image,
    url: 'https://vm.tiktok.com/ZMH3Ro7QUmy9y-4ahJc/',
    name: 'Juego 1'
  },
  {
    id: 2,
    image: juego2Image,
    url: 'https://vm.tiktok.com/ZMH3RovwkkNbB-Y6UiN/',
    name: 'Juego 2'
  },
  {
    id: 3,
    image: juego3Image,
    url: 'https://vm.tiktok.com/ZMH3RonK6SxSN-O1GaE/',
    name: 'Juego 3'
  },
  {
    id: 4,
    image: juego4Image,
    url: 'https://vm.tiktok.com/ZMH3RoGjWyMrC-IEzyK/',
    name: 'Juego 4'
  }
];

function JuegaConFortiPage() {
  useDocumentTitle();

  const handleGameClick = useCallback((url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <S.PageContainer>
      <S.BannerSection $backgroundImage={banner} />

      <S.ContentSection>

        <S.GamesGrid>
          {GAMES.map((game) => (
            <S.GameCard
              key={game.id}
              onClick={() => handleGameClick(game.url)}
              aria-label={`Jugar ${game.name}`}
            >
              <S.GameImageContainer>
                <S.GameImage src={game.image} alt={game.name} />
              </S.GameImageContainer>
              <S.GameOverlay>
                <S.TikTokIcon>
                  <FaTiktok />
                </S.TikTokIcon>
              </S.GameOverlay>
            </S.GameCard>
          ))}
        </S.GamesGrid>
      </S.ContentSection>
    </S.PageContainer>
  );
}

export default JuegaConFortiPage;

